module.exports = {
      id: "blockquote-usage",
      viewBox: "0 0 43 36",
      url: __webpack_public_path__ + "svg-sprite.svg#blockquote",
      toString: function () {
        return this.url;
      }
    }